export default __webpack_public_path__ + "static/media/tickets_desk@2x.8a3b3865.png";